class AnimatedScale extends HTMLElement {
  constructor() {
    super();

    this.observerIntersection = null;
    this.animationClass = null;
    this.animationEnabled = false;
  }

  connectedCallback() {
    this.animationClass =
      this.getAttribute('data-animation-class') || 'animation-scale';
    this.animationEnabled =
      this.getAttribute('data-animation-enabled') === 'true';

    if (!this.animationEnabled) {
      return null;
    }

    this.observerIntersection = new IntersectionObserver(
      this.observationCallback.bind(this),
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.1,
      }
    );

    this.observerIntersection.observe(this);
  }

  disconnectedCallback() {
    if (this.observerIntersection) {
      this.observerIntersection.disconnect();
    }
  }

  observationCallback(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.init();
        observer.unobserve(entry.target);
      }
    });
  }

  init() {
    this.classList.add(this.animationClass);
  }
}

if (!customElements.get('animated-scale')) {
  customElements.define('animated-scale', AnimatedScale);
} else {
  console.log('Custom element "animated-scale" is already defined.');
}
